import React from 'react';
import KeyValueList from '@components/v2/KeyValueList';
import Label from '@components/Label';
import ExternalEntitySelector from '@components/v2/ExternalEntitySelector';
import BuildingSelector from '@components/v2/BuildingSelector';
import { translate } from '@utils/i18n';
import getGeneralInfo from '../utils/getGeneralInfo';
import { namespace } from '../constants';
export default function GeneralInformation({ proposal, handleFieldUpdate, handleBuildingUpdate }) {
    var _a, _b, _c, _d;
    const detailInfo = getGeneralInfo(proposal);
    return (React.createElement(React.Fragment, null,
        React.createElement(KeyValueList, { items: detailInfo.group1, onEdit: handleFieldUpdate }),
        React.createElement("div", { className: "keyValueListContainer" },
            React.createElement("div", { className: "info-row" },
                React.createElement(Label, { htmlFor: translate('proposal_type', { namespace: `${namespace}.fields` }), className: "info-key" },
                    translate('proposal_type', { namespace: `${namespace}.fields` }),
                    ":"),
                React.createElement(ExternalEntitySelector, { className: "info-value", url: "/api/internal/proposal_types", allowClear: false, value: ((_b = (_a = proposal.proposalType) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()) || null, onChange: (proposalType) => {
                        handleFieldUpdate('proposalTypeId', (proposalType === null || proposalType === void 0 ? void 0 : proposalType.id) || null);
                    } })),
            React.createElement("div", { className: "info-row" },
                React.createElement(Label, { htmlFor: translate('building', { namespace: `${namespace}.fields` }), className: "info-key" },
                    translate('building', { namespace: `${namespace}.fields` }),
                    ":"),
                React.createElement(BuildingSelector, { className: "info-value", value: {
                        label: ((_c = proposal.building) === null || _c === void 0 ? void 0 : _c.name) || '',
                        value: ((_d = proposal.building) === null || _d === void 0 ? void 0 : _d.id) || -1
                    }, onChange: (building) => {
                        if (building) {
                            handleBuildingUpdate({
                                id: building.value,
                                name: building.label
                            });
                        }
                    } })))));
}
